<!--DomainGuide/index-->

<template>
    <div class="mx-auto px-6 py-12 xl:max-w-[1528px]">
        <div class="mb-[42px]">
            <h1 class="text-[21px] font-medium leading-normal text-gray-900">
                {{ $t("vue.domain_wizard_page_title") }}
            </h1>
            <p class="mt-2 text-[12.25px] leading-[142%] text-gray-600">
                {{ $t("vue.domain_wizard_page_subtitle") }}
            </p>
        </div>

        <DomainWizard
            :domains-count="domainsCount"
            :domains="domains"
            :uuid="uuid"
            :requested-domain="requestedDomain"
            :selected-domain="selectedDomain"
            :is-trialing="isTrialing"
            :is-trial-extended="isTrialExtended"
            :is-basic-plan="isBasicPlan"
            :is-scale-plan="isScalePlan"
            :subscription-level="subscriptionLevel"
            :subscription-period="subscriptionPeriod"
            :is-cloudflare="isCloudflare"
            :empty-slots="emptySlots"
        />
    </div>

    <TrialEndedPopup />
    <!--    <ExtendYourTrialPopup />-->
    <!--    <FreePlanPopup />-->
</template>

<script setup lang="ts">
import { useTranslations } from "@/composables/useTranslations.ts";
import route from "ziggy-js";
import { create } from "@/composables/useNotifications.ts";
import DateRangePicker from "@/Pages/Reports/components/DateRangePicker.vue";
import DomainWizard from "@/components/Special/DomainWizard.vue";
import InfoCard from "@/components/Content/InfoCard.vue";

const { t } = useTranslations();

const props = defineProps({
    domainsCount: { type: Number, default: 0 },
    domains: { type: Array, default: () => [] },
    uuid: { type: String, required: true },
    requestedDomain: { type: String, default: "" },
    selectedDomain: { type: Object, default: null },
    isTrialing: { type: Boolean, default: false },
    isTrialExtended: { type: Boolean, default: false },
    isBasicPlan: { type: Boolean, default: false },
    isScalePlan: { type: Boolean, default: false },
    subscriptionLevel: { type: String, default: "" },
    subscriptionPeriod: { type: String, default: "" },
    isCloudflare: { type: Boolean, default: false },
    emptySlots: { type: Number, default: 0 },
});

const { domainsCount, domains } = props;
</script>

<style scoped></style>
